// Who a league is for — one question with one control, age included.
//
// Lives here rather than on the admin page because the public league page
// needs the labels too, and a public route importing an admin page pulls the
// whole admin bundle along with it.
//
// `juniors` is still written to the league doc, derived from the type, because
// a dozen places read it to decide whether sign-up asks for a guardian and a
// date of birth. Deriving keeps that single answer while leaving only one
// thing for an admin to set.

export const LEAGUE_TYPES = [
  { id: 'coed',         label: 'Coed' },
  { id: 'mens',         label: "Men's" },
  { id: 'womens',       label: "Women's" },
  { id: 'junior_coed',  label: 'Junior Coed' },
  { id: 'junior_girls', label: 'Junior Girls' },
  { id: 'junior_boys',  label: 'Junior Boys' },
];

export const LEAGUE_TYPE_LABEL = LEAGUE_TYPES
  .reduce((m, t) => ({ ...m, [t.id]: t.label }), {});

export const LEAGUE_TYPE_HELP = {
  coed: 'Mixed adult teams',
  mens: 'Adult men only',
  womens: 'Adult women only',
  junior_coed: 'Sign-up asks for a guardian and date of birth',
  junior_girls: 'Sign-up asks for a guardian and date of birth',
  junior_boys: 'Sign-up asks for a guardian and date of birth',
};

/** Whether a league type is a junior one — the source of the `juniors` flag. */
export const isJuniorType = (t) => String(t || '').startsWith('junior');

/**
 * The type of a league that may predate the field.
 *
 * Those carry only the boolean, so a junior league read as 'coed' would stop
 * asking for a guardian — the one thing the flag exists to control.
 */
export const leagueTypeOf = (league) =>
  league?.leagueType || (league?.juniors === true ? 'junior_coed' : 'coed');

export const leagueTypeLabel = (league) =>
  LEAGUE_TYPE_LABEL[leagueTypeOf(league)] || 'Coed';
